export default __webpack_public_path__ + "static/media/PaymentArrow.63ed2f74.svg";